import React, { useState } from "react";
import classnames from "classnames";
import Collapse from "reactstrap/lib/Collapse";
import Styles from "./Faq.module.scss";
import Link from "next/link";

//Icons
import Plus from "@vahak/core/dist/icons/Plus.svg";
import Minus from "@vahak/core/dist/icons/Minus.svg";
import FaqIcon from "@vahak/core/dist/icons/nf_faq.svg";

import { useTranslation } from "next-i18next";
import { sanitize } from "isomorphic-dompurify";

interface FaqProps {
    faqs: any;
    sectionTitle: string;
    sectionText?: string;
    sectionCalss?: string;
    viewAllFaqClass?: string;
}

interface DataProps {
    question: string;
    subContent: any;
    response: string;
}

const Faq = ({ faqs, sectionTitle, sectionText, sectionCalss, viewAllFaqClass }: FaqProps) => {
    const [activeFaq, setActiveFaq] = useState(0);
    const [isOpen, setIsOpen] = useState(true);
    const { t } = useTranslation("servicePages");

    const handleisOpen = (val: any) => {
        const { currentFaqIndex, isOpen } = val;
        setActiveFaq(parseInt(currentFaqIndex));
        setIsOpen(!isOpen);
    };

    return (
        <section className={classnames(Styles.main, sectionCalss)}>
            <div className={classnames(Styles.conainer, "container")}>
                <div className={Styles.heading}>
                    <h2>{sectionTitle}</h2>
                </div>
                <div className={Styles.faqContainer}>
                    {faqs?.map((data: any) =>
                        data.faqQuestions.map((question: DataProps, index: number) => (
                            <div className={Styles.faqBox} key={index}>
                                <div
                                    className={Styles.faqTitle}
                                    onClick={() =>
                                        handleisOpen({
                                            currentFaqIndex: index,
                                            isOpen: activeFaq === index ? isOpen : false
                                        })
                                    }
                                >
                                    <h3>{question.question}</h3>
                                    <div className={Styles.collapseBtn}>
                                        {activeFaq === index && isOpen ? <Minus /> : <Plus />}
                                    </div>
                                </div>
                                <Collapse isOpen={activeFaq === index ? isOpen : false}>
                                    <div className={Styles.faqDescription}>
                                        {question.response ? (
                                            <p dangerouslySetInnerHTML={{ __html: sanitize(question.response) }} />
                                        ) : (
                                            ""
                                        )}
                                        <ul className={Styles.subcontent}>
                                            {question.subContent?.map((content: any, index: number) => (
                                                <li
                                                    key={index}
                                                    dangerouslySetInnerHTML={{ __html: sanitize(content) }}
                                                />
                                            ))}
                                        </ul>
                                    </div>
                                </Collapse>
                            </div>
                        ))
                    )}
                </div>
                <div className={classnames(Styles.viewAllFaq, viewAllFaqClass)}>
                    <p>
                        <span>
                            <FaqIcon />
                        </span>
                        {t("servicePages:online-load-booking.Faq.last_section")}
                        <Link href="/frequently-asked-questions" prefetch={false}>
                            {t("servicePages:online-load-booking.Faq.Visit_our_FAQs_Page")}
                        </Link>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Faq;
